// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3_SKw1"};